import React from "react";

const Add = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
    <path className="u_fill"
        d="M17.137 20.21v-5.309h1.716v5.31h5.166v1.766h-5.156v5.309h-1.716v-5.299h-5.166v-1.766h5.156v-.01z"
        fill={fill}
    />
    <path className="u_fill"
        d="M30.87 2H5.13C3.404 2 2 3.446 2 5.223v25.554C2 32.554 3.404 34 5.13 34h25.74c1.726 0 3.13-1.446 3.13-3.223V5.223C34 3.446 32.596 2 30.87 2zm-1.334 3.047c.833 0 1.505.692 1.505 1.55 0 .857-.672 1.549-1.505 1.549-.833 0-1.505-.692-1.505-1.55 0-.857.672-1.549 1.505-1.549zm-5.016 0c.833 0 1.505.692 1.505 1.55 0 .857-.672 1.549-1.505 1.549-.832 0-1.504-.692-1.504-1.55 0-.857.672-1.549 1.504-1.549zm-5.015 0c.832 0 1.504.692 1.504 1.55 0 .857-.672 1.549-1.504 1.549-.833 0-1.505-.692-1.505-1.55 0-.857.672-1.549 1.505-1.549zm12.228 25.73h-.01a.865.865 0 01-.853.878H5.13a.865.865 0 01-.853-.878V11.245h27.456v19.532z"
        fill={fill}
    />
    </svg>
);

export default Add;


